import React, { createContext, FC, ReactNode, useContext, useState } from 'react'

interface IContextModel {
  activeDoctorPage: number
  setActiveDoctorPage: React.Dispatch<React.SetStateAction<number>>
}
const ReceiveTurnContext = createContext<IContextModel | undefined>(undefined)

export const ReceiveTurnContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [activeDoctorPage, setActiveDoctorPage] = useState<number>(1)

  const contextValues: IContextModel = { activeDoctorPage, setActiveDoctorPage }

  return <ReceiveTurnContext.Provider value={contextValues}>{children}</ReceiveTurnContext.Provider>
}

export const useReceiveTurnContext = () => useContext(ReceiveTurnContext)!
